<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";
import _ from "lodash";
// import $ from 'jquery';

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Pagination,
    Datatable,
  },
  data() {
    let sortOrders = [];
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "250px", label: "Dahan Profesi", name: "nama_dahan" },
      { width: "250px", label: "Profesi", name: "nama_profesi" },
      { width: "350px", label: "Sumber Kompetensi", name: "sumber_kompetensi" },
      { width: "350px", label: "Kode Kompetensi", name: "kode_kompetensi" },
      { width: "350px", label: "Kompetensi", name: "nama_kompetensi" },
      { width: "250px", label: "Level Proficiency", name: "nama_level" },
      { width: "250px", label: "Tools", name: "tools" },
      { width: "auto", label: "Jumlah Soal PG", name: "total_soal_pg" },
      { width: "auto", label: "Jumlah Soal BS", name: "total_soal_bs" },
      {
        width: "auto",
        label: "Jumlah Soal Menjodohkan",
        name: "total_soal_menjodohkan",
      },
      { width: "auto", label: "Jumlah Soal Esai", name: "total_soal_esai" },
      { width: "160px", label: "Status Review", name: "-" },
      { width: "450px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const menu = "Review Soal Tools Asesmen";

    return {
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      isWriteSimulasi: localStorage.getItem("isWrite"),
      isReadSimulasi: localStorage.getItem("isRead"),
      isWriteSetup: localStorage.getItem("isWrite"),
      isReadSetup: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      columns: columns,
      sortKey: "nama_kompetensi",
      sortOrders: sortOrders,
      options: [],
      optionProfesi: [],
      optionDahanProfesi: [],
      optionFilterKodeKompetensi: [],
      filterKodeKompetensi: [],
      filterKompetensi: [],
      modalEdit: false,
      loadingTable: true,
      listLevelKompetensi: [],
      listPenyusun: [],
      listDirkom: [],
      tableData: [],
      tableFilter: {
        status: 1,
        status_review: "",
        search: "",
        per_page: 10,
        page: 0,
        kompetensi: "",
        level: "",
        tools: "",
        kode_kompetensi: "",
        profesi: "",
        dahan_profesi: "",
        column: "",
        dir: "desc",
      },
      pagination: {
        total: "",
        from: "",
        to: "",
        page: "",
        per_page: "",
        links: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
      },
      idLevelKompetensi: "",
      namaKompetensi: "",
      kodeKompetensi: "",
      idKompetensi: "",
      idProfesi: "",
      kodeProfesi: "",
      namaProfesi: "",
      jenisKompetensi: 1,
      dirkom: "",
      penyusun: [],
    };
  },
  async mounted() {
    this.getKompetensi();
    this.getKompetensiFilter();
    this.getKodeKompetensiFilter();
    this.getLevelKompetensi();
    this.getProfesi();
    this.getPenyusun();
    this.getDahanProfesi();

    this.filterKodeKompetensi = _.debounce(
      this.searchKodeKompetensi.bind(this),
      500
    );
    this.filterKompetensi = _.debounce(this.searchKompetensi.bind(this), 500);
    this.filterProfesi = _.debounce(this.searchProfesi.bind(this), 500);
    this.filterDahanProfesi = _.debounce(
      this.searchDahanProfesi.bind(this),
      500
    );
  },
  methods: {
    async searchKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKompetensiFilter(search, loading);
      }
    },
    async getKompetensiFilter(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.options = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchKodeKompetensi(search, loading) {
      if (search.length) {
        loading(true);
        await this.getKodeKompetensiFilter(search, loading);
      }
    },
    async getKodeKompetensiFilter(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kompetensi/all",
          {
            params: {
              search: search,
              limit: 10,
              col: "kode_kompetensi",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.optionFilterKodeKompetensi = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchProfesi(search, loading) {
      loading(true);
      await this.getProfesi(search, loading);
    },
    async getProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/profesi/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        )
        .then((response) => {
          this.optionProfesi = response.data.data;
          if (loading) loading(false);
        });
    },
    async searchDahanProfesi(search, loading) {
      loading(true);
      await this.getDahanProfesi(search, loading);
    },
    async getDahanProfesi(search = "", loading) {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/dahan-profesi/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        )
        .then((response) => {
          this.optionDahanProfesi = response.data.data;
          if (loading) loading(false);
        });
    },
    async getPenyusun(search = "") {
      await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "referensi/penyusun-soal/all",
          {
            params: {
              search: search,
              limit: 100,
            },
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        )
        .then((response) => {
          this.listPenyusun = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching penyusun:", error);
        });
    },
    async getKompetensi(resetPage = true) {
      if (resetPage) {
        this.tableFilter.page = 1; // Reset to first page when fetching new data
      }
      this.loadingTable = true;
      const data = await axios({
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "review-soal/tools-asesmen/kompetensi",
        params: this.tableFilter,
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => response.data)
        .catch((error) => {
          console.log(error);
          return false;
        });

      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
        // console.log(this.tableData);
      }
      this.loadingTable = false;
    },
    statusReviewBadgeClass(status) {
      switch (status) {
        case "COMPLETED":
          return "bg-success";
        case "REVISION":
          return "bg-danger";
        case "REPAIRED":
          return "bg-primary";
        case "REVIEWED":
          return "bg-info";
        case "PENDING":
          return "bg-secondary";
        default:
          return "bg-secondary";
      }
    },
    statusReviewIcon(status) {
      switch (status) {
        case "COMPLETED":
          return "fa fa-check-circle";
        case "REVISION":
          return "fa fa-pen";
        case "REPAIRED":
          return "fa fa-wrench";
        case "REVIEWED":
          return "fa fa-eye";
        default:
          return "fa fa-clock";
      }
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getKompetensi(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getKompetensi();
    },
    getLevelKompetensi() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/level-kompetensi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => {
          this.listLevelKompetensi = response.data.data;
          console.log(this.listLevelKompetensi);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    isAbleSimulasi(rowForm) {
      if (rowForm.idlevel_kompetensi == 1) {
        return rowForm.total_soal_pg > 0;
      } else if (rowForm.idlevel_kompetensi == 2) {
        return (
          rowForm.total_soal_pg > 0 &&
          rowForm.total_soal_bs > 0 &&
          rowForm.total_soal_menjodohkan > 0
        );
      } else if (rowForm.idlevel_kompetensi == 3) {
        return rowForm.total_soal_pg > 0 && rowForm.total_soal_bs > 0;
      } else if (rowForm.idlevel_kompetensi == 4) {
        return rowForm.total_soal_text > 0;
      }
      return false;
    },
    async simulasiTest(idkompetensi) {
      console.log(idkompetensi);
      await Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin melakukan simulasi tes kompetensi ini ?",
        text: "Data simulasi sebelumnya akan dihapus",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
          });

          // get ipaddress
          // const ipAddress = await $.getJSON(
          //   'https://api.ipify.org?format=json',
          //   function (data) {
          //     return data;
          //   },
          //   function () {
          //     return {};
          //   }
          // );

          // request token sso
          const res = await axios({
            method: "get",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi/" +
              idkompetensi +
              "/simulasi",
            params: {
              ipAddress: "8.8.8.8",
              browser: "Chrome",
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => response.data.data)
            .catch((err) => {
              console.log(err);
              return false;
            });
          const tokenSSO = res ? res.token : false;
          const uniqueId = res ? res.uniqueId : false;
          localStorage.setItem("uniqueId", uniqueId);

          if (tokenSSO) {
            this.$router.push({
              name: "dashboard-assesmen-hc",
              query: {
                sso: tokenSSO,
                isSimulation: true,
              },
            });
          }
        }
      });
      Swal.close();
    },
    async editKompetensi(row) {
      Swal.fire({
        icon: "warning",
        iconHtml: `<i class="fa fa-spinner fa-spin"></i>`,
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      this.namaKompetensi = row.nama_kompetensi;
      this.idLevelKompetensi = row.idlevel_kompetensi;
      this.kodeKompetensi = row.kode_kompetensi;
      this.idKompetensi = row.idkompetensi;
      this.idProfesi = row.id_mprofesi;
      this.kodeProfesi = row.kode_profesi;
      this.namaProfesi = row.nama_profesi;
      this.jenisKompetensi = row.active_flag;
      this.dirkom = row.sumber_kompetensi ?? "";

      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/kompetensi/" +
          row.idkompetensi +
          "/penyusun-soal",
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => {
          this.penyusun = response.data.data.map((item) => ({
            penyusun: item.penyusun_soal,
            jumlah: item.jumlah,
          }));
        })
        .catch((error) => {
          console.error("Error fetching penyusun:", error);
        });
      Swal.close();

      this.modalEdit = true;
    },
    addPenyusun() {
      this.penyusun.push({
        penyusun: "",
        jumlah: 0,
      });
    },
    async updateKompetensi() {
      const data = await axios({
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/kompetensi/" +
          this.idKompetensi,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
        data: {
          nama_kompetensi: this.namaKompetensi,
          level_kompetensi_idlevel_kompetensi: this.idLevelKompetensi,
          id_mprofesi: this.idProfesi,
          penyusun: this.penyusun,
          jenis_kompetensi: this.jenisKompetensi,
          dirkom: this.dirkom,
        },
      })
        .then(() => true)
        .catch(async (err) => {
          console.log("err update data:", err);
          const errMessage =
            (await err?.response?.data?.data) == "Data found"
              ? "Kompetensi tersebut sudah ada"
              : "";
          Swal.fire({
            icon: "error",
            title: "Data gagal disimpan",
            text: errMessage,
            timer: 1500,
            showConfirmButton: false,
          });
          return false;
        });
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Data berhasil disimpan",
          timer: 1500,
          showConfirmButton: false,
        });
        this.modalEdit = false;
        this.getKompetensi();
      }
    },
    disableKompetensi(data) {
      let title = data.active_flag === 0 ? "enable" : "disable";
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin ?",
        text: "Data ini akan di-" + title,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "warning",
            iconHtml: `<i class="fa fa-spinner fa-spin"></i>`,
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
          });

          const body = {
            nama_kompetensi: data.nama_kompetensi,
            level_kompetensi_idlevel_kompetensi: data.idlevel_kompetensi,
            active_flag: data.active_flag === 1 ? 0 : 1,
            updated_by: "",
          };
          axios
            .put(
              process.env.VUE_APP_BACKEND_URL_VERSION +
                "master/kompetensi/" +
                data.idkompetensi,
              body,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.access_token,
                },
              }
            )
            .then((response) => {
              if (data.active_flag === 0) {
                Swal.fire({
                  icon: "success",
                  title: "Data berhasil enable",
                  timer: 1500,
                  showConfirmButton: false,
                });
              } else if (data.active_flag === 1 || data.active_flag === 2) {
                Swal.fire({
                  icon: "success",
                  title: "Data berhasil disable",
                  timer: 1500,
                  showConfirmButton: false,
                });
              }
              console.log(response);
              this.getKompetensi();
            })
            .catch((error) => {
              if (data.active_flag === 0) {
                Swal.fire({
                  icon: "error",
                  title: "Data gagal enable",
                  timer: 1500,
                  showConfirmButton: false,
                });
              } else if (data.active_flag === 1) {
                Swal.fire({
                  icon: "error",
                  title: "Data gagal disable",
                  timer: 1500,
                  showConfirmButton: false,
                });
              }
              console.error(error);
            });
        }
      });
    },
    deleteKompetensi(data) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin ?",
        text: "Data ini akan dihapus permanen",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "warning",
            iconHtml: `<i class="fa fa-spinner fa-spin"></i>`,
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
          });

          const config = {
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi/" +
              data.idkompetensi,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          };
          axios(config)
            .then((response) => {
              Swal.fire({
                icon: "success",
                title: "Data berhasil dihapus",
                timer: 1500,
                showConfirmButton: false,
              });
              console.log(response);
              this.getKompetensi();
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Data gagal dihapus",
                timer: 1500,
                showConfirmButton: false,
              });
              console.error({ "error hapus": error });
            });
        }
      });
    },
    exportDataSoal(idkompetensi) {
      let params = new URLSearchParams({
        idkompetensi: idkompetensi,
      }).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/kompetensi-soal?" +
          params,
        "_blank"
      );
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between gap-2 mb-2">
              <div class="card-title">Daftar Kompetensi</div>
            </div>
            <hr />
            <div class="row">
              <div class="form-group col-md-3 mb-3">
                <label for="filterDahanProfesi">Dahan Profesi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionDahanProfesi"
                  :reduce="(item) => item.dp_id"
                  label="dp_name"
                  v-model="tableFilter.dahan_profesi"
                  placeholder="Dahan Profesi"
                  @search="filterDahanProfesi"
                  @update:modelValue="getKompetensi()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterProfesi">Profesi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionProfesi"
                  :reduce="(item) => item.id_mprofesi"
                  label="nama_profesi"
                  v-model="tableFilter.profesi"
                  placeholder="Profesi"
                  @search="filterProfesi"
                  @update:modelValue="getKompetensi()"
                />
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKompetensi">Kode Kompetensi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="optionFilterKodeKompetensi"
                  :reduce="(item) => item.kode_kompetensi"
                  label="kode_kompetensi"
                  v-model="tableFilter.kode_kompetensi"
                  placeholder="Filter Kode Kompetensi"
                  @search="filterKodeKompetensi"
                  @update:modelValue="getKompetensi()"
                >
                </v-select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterKompetensi">Kompetensi</label>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="options"
                  :reduce="(item) => item.nama_kompetensi"
                  label="nama_kompetensi"
                  v-model="tableFilter.kompetensi"
                  placeholder="Filter Kompetensi"
                  @search="filterKompetensi"
                  @update:modelValue="getKompetensi()"
                >
                </v-select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterLevel">Level</label>
                <select
                  id="filterLevel"
                  class="form-control"
                  v-model="tableFilter.level"
                  @update:modelValue="getKompetensi()"
                >
                  <option value="">Semua Level</option>
                  <option
                    v-for="level in listLevelKompetensi"
                    :key="level.idlevel_kompetensi"
                    :value="level.nama_level"
                  >
                    {{ level.nama_level }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterTools">Tools</label>
                <select
                  class="form-control"
                  id="filterTools"
                  v-model="tableFilter.tools"
                  @update:modelValue="getKompetensi()"
                >
                  <option value="">Semua</option>
                  <option value="Lengkap">Lengkap</option>
                  <option value="Tidak Lengkap">Tidak Lengkap</option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="statusTable">Status</label>
                <select
                  class="form-control"
                  id="statusTable"
                  v-model="tableFilter.status"
                  @update:modelValue="getKompetensi()"
                >
                  <option value="1">ENABLE</option>
                  <option value="2">DUMMY</option>
                  <option value="0">DISABLE</option>
                </select>
              </div>
              <div class="form-group col-md-3 mb-3">
                <label for="filterStatusReview">Status Review</label>
                <select
                  class="form-control"
                  id="filterStatusReview"
                  v-model="tableFilter.status_review"
                  @update:modelValue="getKompetensi()"
                >
                  <option value="">SEMUA STATUS</option>
                  <option value="PENDING">PENDING</option>
                  <option value="REVISION">REVISION</option>
                  <option value="REVIEWED">REVIEWED</option>
                  <option value="COMPLETED">COMPLETED</option>
                </select>
              </div>
              <!-- <div class="form-group col-lg d-flex align-items-end">
                <div>
                  <button class="btn btn-primary" @click="getKompetensi()">
                    <i class="fa fa-search me-1"></i>Filter
                  </button>
                </div>
              </div> -->
            </div>
            <hr />
            <div class="d-flex justify-content-between">
              <table class="mb-2">
                <tr>
                  <td>Show</td>
                  <td>
                    <select
                      class="form-control form-control-sm"
                      id="showpaginatetable"
                      v-model="tableFilter.per_page"
                      @change="getKompetensi()"
                    >
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </select>
                  </td>
                  <td>Entries</td>
                </tr>
              </table>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="99" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading
                  </td>
                </tr>
                <tr v-else-if="tableData.length < 1">
                  <td colspan="99" class="text-center">Data Empty</td>
                </tr>
                <tr v-else v-for="(rowForm, index) in tableData" :key="index">
                  <td class="text-center">{{ pagination.from + index }}</td>
                  <td>{{ rowForm.nama_dahan ?? "-" }}</td>
                  <td>{{ rowForm.nama_profesi ?? "-" }}</td>
                  <td>{{ rowForm.sumber_kompetensi ?? "-" }}</td>
                  <td>
                    {{ rowForm.kode_kompetensi || "-" }}
                  </td>
                  <td>{{ rowForm.nama_kompetensi }}</td>
                  <td>{{ rowForm.nama_level }}</td>
                  <td>
                    <span v-if="rowForm.idlevel_kompetensi == 1">
                      <span v-if="rowForm.total_soal_pg > 0">Lengkap</span>
                      <span v-else>Tidak Lengkap</span>
                    </span>
                    <span v-else-if="rowForm.idlevel_kompetensi == 2">
                      <span
                        v-if="
                          rowForm.total_soal_pg > 0 &&
                          rowForm.total_soal_bs > 0 &&
                          rowForm.total_soal_menjodohkan > 0
                        "
                      >
                        Lengkap
                      </span>
                      <span v-else>Tidak Lengkap</span>
                    </span>
                    <span v-else-if="rowForm.idlevel_kompetensi == 3">
                      <span
                        v-if="
                          rowForm.total_soal_pg > 0 && rowForm.total_soal_bs > 0
                        "
                      >
                        Lengkap
                      </span>
                      <span v-else>Tidak Lengkap</span>
                    </span>
                    <span v-else-if="rowForm.idlevel_kompetensi == 4">
                      <span v-if="rowForm.total_soal_text > 0"> Lengkap </span>
                      <span v-else>Tidak Lengkap</span>
                    </span>
                  </td>
                  <td class="text-center">{{ rowForm.total_soal_pg }}</td>
                  <td class="text-center">{{ rowForm.total_soal_bs }}</td>
                  <td class="text-center">
                    {{ rowForm.total_soal_menjodohkan }}
                  </td>
                  <td class="text-center">{{ rowForm.total_soal_text }}</td>
                  <td class="text-center">
                    <span
                      class="badge bg-gradient rounded-pill py-2 px-4 fw-bold text-nowrap w-100"
                      :class="statusReviewBadgeClass(rowForm.status_review)"
                    >
                      <i
                        :class="statusReviewIcon(rowForm.status_review)"
                        class="me-1"
                      ></i>
                      {{ rowForm.status_review || "PENDING" }}
                    </span>
                  </td>
                  <td class="text-center">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-primary dropdown-toggle btn-sm w-100"
                        data-bs-toggle="dropdown"
                        v-if="isReadSetup || isReadSetup == 1 || isWriteSetup || isWriteSetup == 1"
                      >
                        <i class="fas fa-edit"></i> Review
                      </button>
                      <div class="dropdown-menu">
                        <router-link
                          class="dropdown-item"
                          :to="`/review-soal/tools-asesmen/${rowForm.idkompetensi}/soal-pilihan-ganda`"
                          v-if="rowForm.idlevel_kompetensi !== 4"
                        >
                          Pilihan Ganda
                        </router-link>
                        <router-link
                          class="dropdown-item"
                          :to="`/review-soal/tools-asesmen/${rowForm.idkompetensi}/soal-benar-salah`"
                          v-if="
                            rowForm.idlevel_kompetensi === 2 ||
                            rowForm.idlevel_kompetensi === 3
                          "
                        >
                          Benar salah
                        </router-link>
                        <router-link
                          class="dropdown-item"
                          :to="`/review-soal/tools-asesmen/${rowForm.idkompetensi}/soal-jodoh`"
                          v-if="rowForm.idlevel_kompetensi === 2"
                        >
                          Menjodohkan
                        </router-link>
                        <router-link
                          class="dropdown-item"
                          :to="`/review-soal/tools-asesmen/${rowForm.idkompetensi}/soal-text`"
                          v-if="rowForm.idlevel_kompetensi === 4"
                        >
                          Esai
                        </router-link>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <Pagination :pagination="pagination" @to-page="toPage"></Pagination>

            <hr class="five-dashes" />
            <div class="mt-2 d-flex flex-column align-items-end">
              <table class="table table-borderless mb-0 w-auto align-middle">
                <thead>
                  <tr>
                    <th colspan="3" class="text-end fw-bold p-2">
                      Keterangan Status
                      <i class="fas fa-info-circle text-primary ms-1"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-2 text-muted text-end">Belum ada soal yang direview di kompetensi ini</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-secondary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-clock me-1"></i> PENDING
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Ada soal di kompetensi ini yang ditandai perlu revisi</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-danger py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-pen me-1"></i> REVISION
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Hasil review sudah dikirim, menunggu diperbaiki di Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-info py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-eye me-1"></i> REVIEWED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Hasil perbaikan sudah dikirim dari Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-primary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-wrench me-1"></i> REPAIRED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Semua soal di kompetensi ini sudah selesai di-approve</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-success py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-check-circle me-1"></i> COMPLETED
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>

  <b-modal v-model="modalEdit" title="Edit Kompetensi" hide-footer>
    <b-form class="p-0">
      <!-- <b-form-group label="Kode Kompetensi" label-for="kodeKompetensi">
        <b-form-input
          id="kodeKompetensi"
          v-model="kodeKompetensi"
          placeholder="Kode Kompetensi..."
          required
        ></b-form-input>
      </b-form-group> -->
      <b-form-group label="Kompetensi" label-for="kompetensi">
        <b-form-input
          id="kompetensi"
          v-model="namaKompetensi"
          placeholder="Nama Kompetensi..."
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Level Proficiency" label-for="level_proficiency">
        <select
          class="form-select"
          id="level_proficiency"
          v-model="idLevelKompetensi"
        >
          <option value="">-- Pilih Level Proficiency --</option>
          <option
            v-for="list in listLevelKompetensi"
            :key="list.idlevel_kompetensi"
            :value="list.idlevel_kompetensi"
          >
            {{ list.nama_level }}
          </option>
        </select>
      </b-form-group>
      <b-form-group label="Profesi" label-for="profesi">
        <v-select
          id="parent_menu"
          class="style-chooser"
          :options="optionProfesi"
          :reduce="(item) => item.id_mprofesi"
          label="nama_profesi"
          v-model="idProfesi"
          placeholder="Profesi"
          @search="filterProfesi"
        />
      </b-form-group>
      <b-form-group label="Jenis Kompetensi" label-for="jenisKompetensi">
        <select
          class="form-select"
          id="jenisKompetensi"
          v-model="jenisKompetensi"
        >
          <option value="1">Biasa</option>
          <option value="2">Dummy</option>
        </select>
      </b-form-group>
      <b-form-group label="Dirkom" label-for="dirkomEdit">
        <select
          class="form-select"
          id="dirkomEdit"
          v-model="dirkom"
        >
          <option value="">-- Pilih Dirkom --</option>
          <option value="DIRKOM">DIRKOM</option>
          <option value="NONDIRKOM">NONDIRKOM</option>
        </select>
      </b-form-group>
      <div class="mb-3">
        <table class="table table-sm table-condensed table-bordered">
          <thead class="bg-dark text-white">
            <tr class="text-center">
              <td width="70%">Penyusun</td>
              <td colspan="2">Jumlah</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in penyusun" :key="index">
              <td>
                <v-select
                  id="parent_menu"
                  class="style-chooser"
                  :options="listPenyusun"
                  label="nama"
                  v-model="penyusun[index].penyusun"
                  placeholder="Pilih Penyusun"
                  required
                />
              </td>
              <td>
                <b-form-input
                  v-model="item.jumlah"
                  type="number"
                  placeholder="Jumlah..."
                  required
                ></b-form-input>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-danger btn-sm"
                  @click="penyusun.splice(index, 1)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="99">
                <div class="d-grid">
                  <button class="btn btn-success btn-sm" @click="addPenyusun()">
                    <i class="fa fa-plus me-1"></i> Tambah Penyusun
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        type="submit"
        class="btn btn-primary float-end"
        @click="updateKompetensi()"
      >
        Simpan
      </button>
    </b-form>
  </b-modal>
</template>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  border: none;
  color: #394066;
  /* text-transform: lowercase; */
}
.style-chooser .vs__dropdown-toggle {
  border: 1px solid #ced4da;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}
</style>
